export const APP_CHAT_LEADS_ROUTE = "/chat-leads";
